import type { Params, LimitsType } from 'app/common/components/Cafeteria/dataTypes/customer/settings/limit'

import { apiLimitToString } from '../helpers'

import type { Request } from '../../../../index'


type ApiParams = {
  customer_id: number
  personal_limit?: number | null
  sale_points_personal_limits?: Array<{
    sale_point_id: number
    value: number
  }>
}

export const convertParams = (params: Params): [ApiParams, null] => {
  const { customerID } = params

  if ('personalLimit' in params) {
    const { personalLimit } = params
    return [{
      customer_id: parseInt(customerID, 10),
      personal_limit: personalLimit ? parseFloat(String(personalLimit)) : null,
    }, null]
  }

  if ('sellPointsPersonalLimits' in params) {
    const { sellPointsPersonalLimits } = params
    return [{
      customer_id: parseInt(customerID, 10),
      sale_points_personal_limits: sellPointsPersonalLimits.map(({ sellPointID, value }) => ({
        sale_point_id: parseInt(sellPointID, 10),
        value: parseFloat(String(value)),
      })),
    }, null]
  }

  return [{ customer_id: parseInt(customerID, 10) }, null] as never
}

type ResultApi = {
  common_limit: number | null
  personal_limit: number | null
  sale_points_personal_limits?: Array<{
    sale_point_id: number
    value: number | null
  }>
}

export const convertResult = (res: ResultApi): LimitsType => {
  const {
    common_limit: commonLimit,
    personal_limit: personalLimit,
    sale_points_personal_limits: salePointsPersonalLimits,
  } = res

  return {
    commonLimit: apiLimitToString(commonLimit),
    personalLimit: apiLimitToString(personalLimit),
    sellPointsPersonalLimits: salePointsPersonalLimits?.map(({ sale_point_id: salePointID, value }) => ({
      sellPointID: String(salePointID),
      value: apiLimitToString(value),
    })) || [],
  }
}

export const POST_CAFETERIA_CUSTOMER_SETTINGS_LIMIT: Request<Params, LimitsType, void> = [
  'cafeteria/customer/settings/limit',
  'post',
  ['data'],
]
